import * as React from "react";
import * as store from "../../framework/customStore";
import * as storeActions from "../../models/store/storeActions";
import * as settingsService from "../../services/settingsService";
import { SettingsCustomersList } from "./settingsCustomersList";
import { SettingsEmployeeList } from "./settingsEmployeeList";
import { SettingsContactList } from "./settingsContactList";
import { SettingsVehicleList } from "./settingsVehicleList";
import { SettingsToolList } from "./settingsToolList";
import { SettingsProductList } from "./settingsProductList";
import { SettingsCompetencyList } from "./settingsCompetencyList";
import { SettingsEmployeeCompetencyList } from "./settingsEmployeCompetencyList";
import { SettingsCustomerSitesList } from "./settingsCustomerSitesList";
import { SettingsCostCenterList } from "./settingsCostCenterList";
import { SettingsCustomerTypeList } from "./settingsCustomerTypeList";
import { SettingsEmployeeGroupList } from "./settingsEmployeeGroupList";
import { SettingsVehicleGroupList } from "./settingsVehicleGroupList";
import { SettingsProductGroupList } from "./settingsProductGroupList";
import { IEmployeeParameters } from "../../models/employee/employeeIParameters";
import { IOwnerState, IUserState } from "../../models/store/storeTypes";
import { handleApiError } from "../../models/store/storeEffects";
import { RouteComponentProps } from "react-router-dom";
import { SettingsWorkTimeTypeList } from "./settingsWorkTimeTypeList";
import { SettingsOrderTypeList } from "./settingsOrderTypes/settingsOrderTypes";
import { SettingsRouteList } from "./settingsRouteList";
import { FormsViewContent } from "./formsView/formsView";

/* eslint-disable no-unused-vars */
export const enum SettingsMainMenu {
    Customers = "customers",
    CustomerSites = "customersites",
    Vehicles = "vehicles",
    Competencies = "competencies",
    Products = "products",
    Tools = "tools",
    Employees = "employees",
    EmployeeCompetencies = "employeecompetencies",
    Contacts = "contacts",
    CostCenters = "costcenters",
    CustomerTypes = "customertypes",
    EmployeeGroups = "employeegroups",
    VehicleGroups = "vehiclegroups",
    ProductGroups = "productgroups",
    WorkTimeTypes = "worktimetypes",
    OrderTypes = "ordertypes",
    Routes = "routes",
    Forms = "forms",
}

export const enum SettingsMainSubMenu {
    Customers = "customers",
    Products = "products",
    CostCenters = "costcenters",
    Employees = "employees",
    Vehicles = "vehicles",
    WorkTimeTypes = "worktimetypes",
    OrderTypes = "ordertypes",
    Routes = "routes",
    Forms = "forms",
}
/* eslint-enable no-unused-vars */

export interface ISettingsMainOwnProps {}

export interface ISettingsMainStateProps {
    owner: IOwnerState;
    user: IUserState;
}

export interface ISettingsMainDispatchProps {
    setEmployeeParameters: (
        parameters: IEmployeeParameters,
        saveToDb: boolean
    ) => void;
    onLogout: () => void;
}

export interface ISettingsMainPathProps {
    submenu: SettingsMainSubMenu;
    menu: SettingsMainMenu;
}

type SettingsMainProp = ISettingsMainOwnProps &
    ISettingsMainStateProps &
    ISettingsMainDispatchProps &
    RouteComponentProps<ISettingsMainPathProps>;

interface ISettingsMainState {
    settingsMenuItem: SettingsMainMenu;
    isLoading: boolean;
}

export class SettingsMain extends React.Component<
    SettingsMainProp,
    ISettingsMainState
> {
    constructor(props) {
        super(props);

        const menu = props.match.params.menu
            ? (props.match.params.menu as SettingsMainMenu)
            : SettingsMainMenu.Customers;
        this.state = {
            settingsMenuItem: menu,
            isLoading: false,
        };
    }

    componentDidMount(): void {
        this.getSettingsMain();
    }

    componentDidUpdate(prevProps: SettingsMainProp): void {
        const prevMenu = prevProps.match.params.menu;
        const { menu } = this.props.match.params;
        if (prevMenu !== menu) {
            this.setState({
                settingsMenuItem: menu
                    ? (menu as SettingsMainMenu)
                    : SettingsMainMenu.Customers,
            });
        }
    }

    getSettingsMain = (): Promise<void> => {
        const obj = this;
        obj.setState({
            isLoading: true,
        });
        store.customStore.dispatch(storeActions.fetchStart());
        return settingsService
            .getSettingsMain()
            .then(
                (settingsMain) => {
                    store.customStore.dispatch(
                        storeActions.setUserParameters(
                            settingsMain.employeeParameters
                        )
                    );
                },
                (error) => {
                    handleApiError(error, store.customStore.dispatch);
                }
            )
            .finally(() => {
                obj.setState({
                    isLoading: false,
                });
                store.customStore.dispatch(storeActions.fetchEnd());
            });
    };

    render() {
        const state = this.state;
        return (
            <div>
                <div className="row mainContent settingsMain">
                    <div className="col-12">
                        <div className="backgroundBoard">
                            {state.settingsMenuItem ===
                            SettingsMainMenu.Routes ? (
                                <SettingsRouteList />
                                ) : (
                                    <div className="panel">
                                        {state.settingsMenuItem ===
                                            SettingsMainMenu.Customers && (
                                            <SettingsCustomersList />
                                        )}
                                        {state.settingsMenuItem ===
                                            SettingsMainMenu.CustomerSites && (
                                            <SettingsCustomerSitesList />
                                        )}
                                        {state.settingsMenuItem ===
                                            SettingsMainMenu.Vehicles && (
                                            <SettingsVehicleList />
                                        )}
                                        {state.settingsMenuItem ===
                                            SettingsMainMenu.VehicleGroups && (
                                            <SettingsVehicleGroupList />
                                        )}
                                        {state.settingsMenuItem ===
                                            SettingsMainMenu.CostCenters && (
                                            <SettingsCostCenterList />
                                        )}
                                        {state.settingsMenuItem ===
                                            SettingsMainMenu.Competencies && (
                                            <SettingsCompetencyList />
                                        )}
                                        {state.settingsMenuItem ===
                                            SettingsMainMenu.Products && (
                                            <SettingsProductList />
                                        )}
                                        {state.settingsMenuItem ===
                                            SettingsMainMenu.ProductGroups && (
                                            <SettingsProductGroupList />
                                        )}
                                        {state.settingsMenuItem ===
                                            SettingsMainMenu.Tools && (
                                            <SettingsToolList />
                                        )}
                                        {state.settingsMenuItem ===
                                            SettingsMainMenu.Employees && (
                                            <SettingsEmployeeList
                                                setEmployeeParameters={
                                                    this.props.setEmployeeParameters
                                                }
                                            />
                                        )}
                                        {state.settingsMenuItem ===
                                            SettingsMainMenu.EmployeeCompetencies && (
                                            <SettingsEmployeeCompetencyList />
                                        )}
                                        {state.settingsMenuItem ===
                                            SettingsMainMenu.EmployeeGroups && (
                                            <SettingsEmployeeGroupList />
                                        )}
                                        {state.settingsMenuItem ===
                                            SettingsMainMenu.Contacts && (
                                            <SettingsContactList />
                                        )}
                                        {state.settingsMenuItem ===
                                            SettingsMainMenu.CustomerTypes && (
                                            <SettingsCustomerTypeList />
                                        )}
                                        {state.settingsMenuItem ===
                                            SettingsMainMenu.WorkTimeTypes && (
                                            <SettingsWorkTimeTypeList />
                                        )}
                                        {state.settingsMenuItem ===
                                            SettingsMainMenu.OrderTypes && (
                                            <SettingsOrderTypeList />
                                        )}
                                        {state.settingsMenuItem ===
                                            SettingsMainMenu.Forms && (
                                            <FormsViewContent />
                                        )}
                                    </div>
                                )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
